import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";
import ComponentManager from '@/Management/ComponentManager';
import LinkT from '@/Controls/Link';

export default class OptionsLandschaftGroupLinksBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.optionsLandschaftGroupLinks = {
            init: (node, valueAccessor, bindings, view, bindingContext) => {
                let Link = ComponentManager.getControl<typeof LinkT>('Link');

                let optionsLandschaftGroup = $(node);
                let options = valueAccessor();
                let links = options.links();

                options.parent.links = [];

                for (let i = 0; i < links.length; i++) {
                    let link = new Link(links[i], $('<div>').appendTo(optionsLandschaftGroup));
                    let tuple = link.getTuple();

                    options.parent.links.push(link);
                }
            }
        };
    }
}